import { useEffect, useState } from 'react';

export const useFilteredAssets = (
  assets: any,
  filterOption: Object,
  searchText: string,
) => {
  const [filteredAssets, setFilteredAssets] = useState([]);

  useEffect(() => {
    if (!assets || !Array.isArray(assets)) {
      setFilteredAssets([]);
      return;
    }
    let localAssets = [...assets];

    if (filterOption.assetType === 'All Assets' && assets?.length > 0)
      localAssets = [...assets];
    else {
      localAssets = localAssets?.filter(
        (ticket: any) => ticket?.spec?.type === filterOption.assetType,
      );
    }
    // Apply search filter only if searchText exists
    if (searchText) {
      localAssets = localAssets.filter((asset: any) => {
        // Check metadata fields
        const metadataMatch = Object.values(asset?.metadata || {}).some(
          value =>
            value &&
            value.toString().toLowerCase().includes(searchText.toLowerCase()),
        );

        // Check spec fields
        const specMatch = Object.values(asset?.spec || {}).some(
          value =>
            value &&
            value.toString().toLowerCase().includes(searchText.toLowerCase()),
        );

        // Check kind field
        const kindMatch = asset?.kind
          ?.toLowerCase()
          .includes(searchText.toLowerCase());

        return metadataMatch || specMatch || kindMatch;
      });
    }
    setFilteredAssets(localAssets);
  }, [assets, filterOption, searchText]);

  return { filteredAssets };
};
